import { BankOutlined } from '@ant-design/icons'
import { Button, Modal, Select, Spin } from 'antd'
import React, { useEffect, useState } from 'react'
import axiosInstance from '../../../variables/api/axiosInstance';
import { toast } from 'react-toastify';

const ChangeAgenceUtilisateur = ({ utilisateur, buttonStyle, navigate, param, requireActive, isSecurityLocked, securityLockMessage }) => {
    const [agenceModalOpen, setAgenceModalOpen] = useState(false);
    const [selectedAgenceCode, setSelectedAgenceCode] = useState(null);
    const [loading, setLoading] = useState(false);
    const [availableAgences, setAvailableAgences] = useState([]);
    const isDisabled = !utilisateur?.active || isSecurityLocked;
    const disabledButtonStyle = {
        backgroundColor: '#E5E7EB',
        borderColor: '#E5E7EB',
        color: '#9CA3AF',
        boxShadow: 'none',
        cursor: 'not-allowed',
        opacity: 1,
    };

    const utilisateurOrganismeCode =
        utilisateur?.profil?.organisme?.code || utilisateur?.agence?.organisme?.code;

    useEffect(() => {
        if (!agenceModalOpen) return;
        if (!utilisateurOrganismeCode) {
            setAvailableAgences([]);
            return;
        }
        setLoading(true);
        axiosInstance
            .get(`/api/agence/organisme/code/${utilisateurOrganismeCode}`)
            .then(({ data }) => {
                const agencesList = Array.isArray(data) ? data : [];
                setAvailableAgences(agencesList);
                setSelectedAgenceCode((current) => {
                    if (current && agencesList.some((ag) => ag.codeAgence === current)) {
                        return current;
                    }
                    if (
                        utilisateur?.agence?.codeAgence &&
                        agencesList.some((ag) => ag.codeAgence === utilisateur.agence.codeAgence)
                    ) {
                        return utilisateur.agence.codeAgence;
                    }
                    return agencesList?.[0]?.codeAgence || "";
                });
            })
            .catch((err) => {
                console.error(err);
                toast("Erreur lors du chargement des agences");
            })
            .finally(() => setLoading(false));
    }, [agenceModalOpen, utilisateurOrganismeCode, utilisateur?.agence?.codeAgence]);

    const onSubmitChangeAgence = (event) => {
        event?.preventDefault();
        if (requireActive("changer d'agence")) return;
        if (isSecurityLocked) {
            toast(securityLockMessage || "Action non autorisée.");
            return;
        }
        if (!selectedAgenceCode) {
            toast("Veuillez sélectionner une agence");
            return;
        }
        if (!utilisateur?.codeId) return;
        setLoading(true);
        axiosInstance
            .put(`/api/utilisateur/${utilisateur.codeId}/agence/${selectedAgenceCode}`)
            .then((res) => {
                toast("Agence modifiée avec succès");
                setAgenceModalOpen(false);
                navigate(`/details-utilisateur/${res.data.codeId}`, { replace: true });
            })
            .catch((err) => {
                console.error(err);
                toast("Erreur lors du changement d'agence");
            })
            .finally(() => setLoading(false));
    };
    return (
        <div style={{
            backgroundColor: 'white',
            borderRadius: '12px',
            padding: '24px',
            border: '2px solid #E6F0FF',
            transition: 'all 0.3s ease'
        }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '16px' }}>
                <div style={{
                    width: '48px',
                    height: '48px',
                    borderRadius: '12px',
                    backgroundColor: '#E6F0FF',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}>
                    <BankOutlined style={{ fontSize: '24px', color: '#242166' }} />
                </div>
                <div>
                    <h4 style={{ fontSize: '16px', fontWeight: '600', color: '#242166', margin: 0 }}>
                        Agence
                    </h4>
                    <p style={{ fontSize: '12px', color: '#6B7280', margin: 0 }}>
                        Affecter à une agence
                    </p>
                </div>
            </div>
            <p style={{ fontSize: '14px', color: '#6B7280', marginBottom: '16px' }}>
                Changez l'agence d'affectation de l'utilisateur
            </p>
            {securityLockMessage && (
                <p style={{ fontSize: '12px', color: '#b45309', marginBottom: '12px' }}>
                    {securityLockMessage}
                </p>
            )}
            <Button
                icon={<BankOutlined />}
                block
                onClick={() => {
                    if (isSecurityLocked) {
                        toast(securityLockMessage || "Action non autorisée.");
                        return;
                    }
                    setAgenceModalOpen(true);
                }}
                disabled={isDisabled}
                style={
                    isDisabled
                        ? { ...buttonStyle, ...disabledButtonStyle }
                        : { ...buttonStyle, backgroundColor: '#242166', borderColor: '#242166', color: 'white' }
                }
            >
                Changer d'agence
            </Button>

            <Modal
                open={agenceModalOpen && !isSecurityLocked}
                onCancel={() => setAgenceModalOpen(false)}
                zIndex={10000}
                centered
                onOk={onSubmitChangeAgence}
                confirmLoading={loading}
            >
                <form
                    id="changeAgenceForm"
                    className="row g-12"
                    onSubmit={onSubmitChangeAgence}
                >
                    <div className="col-12 col-md-12">
                        <div className="text-center">
                            <p className="address-subtitle">
                                Changer l'agence de{" "}
                                <b>
                                    {utilisateur?.personne?.nom} {utilisateur?.personne?.prenom}
                                </b>
                            </p>
                        </div>
                        <div class="row">
                            <div class="col-md-12 select2-primary">
                                <label class="form-label" for="change-user-agence">
                                    Veuillez sélectionner la nouvelle agence
                                </label>
                                <Select
                                    id="change-user-agence"
                                    style={{ width: "100%" }}
                                    placeholder="Sélectionner une agence"
                                    onChange={(value) => setSelectedAgenceCode(value)}
                                    options={availableAgences.map((ag, id) => ({
                                        label: ag.nom,
                                        value: ag.codeAgence,
                                        key: id,
                                    }))}
                                    value={selectedAgenceCode || undefined}
                                    showSearch
                                    optionFilterProp="label"
                                    loading={loading}
                                    notFoundContent={
                                        loading ? (
                                            <Spin size="small" />
                                        ) : (
                                            "Aucune agence disponible"
                                        )
                                    }
                                />
                            </div>
                        </div>
                    </div>
                </form>
            </Modal>
        </div>
    )
}

export default ChangeAgenceUtilisateur
